//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import type { Class, Doc, Ref } from '@hcengineering/core'
import type { NotificationGroup, NotificationProvider } from '@hcengineering/notification'
import { type Asset, type IntlString, type Plugin, plugin } from '@hcengineering/platform'
import type { TeamsSetting } from './types'

export * from './types'

/**
 * @public
 */
export const teamsId = 'teams' as Plugin

const teams = plugin(teamsId, {
  class: {
    TeamsSetting: '' as Ref<Class<TeamsSetting>>
  },
  icon: {
    Teams: '' as Asset
  },
  providers: {
    TeamsNotificationProvider: '' as Ref<NotificationProvider>
  },
  ids: {
    NotificationGroup: '' as Ref<NotificationGroup>,
    TeamsSetting: '' as Ref<Doc>
  },
  string: {
    Teams: '' as IntlString,
    TeamsNotificationDescription: '' as IntlString,
    WebhookUrl: '' as IntlString,
    WebhookUrlDescription: '' as IntlString
  }
})

export default teams
